var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnreadMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.53 4.8c-.489-.464-1.262-.412-1.726.078l-7.088 7.69-2.628-2.632c-.464-.465-1.238-.465-1.727 0-.464.464-.464 1.239 0 1.729l3.53 3.536c.233.232.542.36.851.36h.026c.335 0 .644-.154.876-.386l7.964-8.62c.464-.542.438-1.29-.077-1.755zm6.058 0c-.49-.464-1.263-.412-1.727.078l-7.088 7.69-.902-.903-1.65 1.78 1.727 1.73c.232.232.542.361.85.361h.027c.335 0 .644-.155.876-.387l7.964-8.62c.438-.516.412-1.264-.077-1.729z",
    fill: "#B5B9BC"
  })));
}

export default SvgUnreadMessage;